<script setup lang="ts">
</script>

<style>
</style>

<template>
  <slot />
</template>